document.addEventListener('DOMContentLoaded', function () {
  var lightbox = document.createElement('div');
  lightbox.className = 'custom-lightbox';
  lightbox.innerHTML =
    '<button type="button" class="custom-lightbox__close" aria-label="Close">&times;</button>' +
    '<button type="button" class="custom-lightbox__arrow custom-lightbox__arrow--prev" aria-label="Previous">&#10094;</button>' +
    '<div class="custom-lightbox__stage">' +
      '<div class="custom-lightbox__track"></div>' +
    '</div>' +
    '<button type="button" class="custom-lightbox__arrow custom-lightbox__arrow--next" aria-label="Next">&#10095;</button>' +
    '<div class="custom-lightbox__counter"><span class="custom-lightbox__counter-current">1</span> / <span class="custom-lightbox__counter-total">1</span></div>';
  document.body.appendChild(lightbox);

  var stageEl = lightbox.querySelector('.custom-lightbox__stage');
  var trackEl = lightbox.querySelector('.custom-lightbox__track');
  var closeBtn = lightbox.querySelector('.custom-lightbox__close');
  var prevBtn = lightbox.querySelector('.custom-lightbox__arrow--prev');
  var nextBtn = lightbox.querySelector('.custom-lightbox__arrow--next');
  var counterCurrent = lightbox.querySelector('.custom-lightbox__counter-current');
  var counterTotal = lightbox.querySelector('.custom-lightbox__counter-total');

  var currentImages = [];
  var currentIndex = 0;

  // --- drag/swipe state (shared by touch + mouse) ---
  var dragStartX = 0;
  var dragStartY = 0;
  var dragDeltaX = 0;
  var isDragging = false;
  var isMouseDown = false;
  var SWIPE_THRESHOLD = 40; // px, minimum horizontal drag to count as a swipe

  function stageWidth() {
    return stageEl.getBoundingClientRect().width || 1;
  }

  // Picks the best-resolution URL for an <img>, since many themes
  // lazy-load a small placeholder into `src` and keep the real image
  // in `data-src` or the largest entry of `srcset`.
  function getFullImageSrc(img) {
    if (!img) return null;

    var explicit = img.getAttribute('data-photoswipe-src') ||
                   img.getAttribute('data-zoom') ||
                   img.getAttribute('data-master') ||
                   img.getAttribute('data-src');
    if (explicit) return normalizeUrl(explicit);

    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset');
    if (srcset) {
      var entries = srcset.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (entries.length) {
        var last = entries[entries.length - 1]; // srcset entries are ordered small -> large
        var url = last.split(' ')[0];
        if (url) return normalizeUrl(url);
      }
    }

    return normalizeUrl(img.currentSrc || img.getAttribute('src'));
  }

  function normalizeUrl(url) {
    if (!url) return null;
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  // Builds one slide per image inside the track. Called each time the
  // lightbox is opened, since the set of images can differ per product.
  function buildSlides() {
    trackEl.innerHTML = currentImages
      .map(function (src) {
        return (
          '<div class="custom-lightbox__slide">' +
            '<img class="custom-lightbox__image" src="' + src + '" alt="">' +
          '</div>'
        );
      })
      .join('');
  }

  // Moves the track so `currentIndex` is centered in the stage.
  // `extraOffsetPx` is used while dragging, to follow the finger/cursor
  // live before it snaps to a slide on release.
  function setTrackPosition(withTransition, extraOffsetPx) {
    var offset = -(currentIndex * stageWidth()) + (extraOffsetPx || 0);
    trackEl.style.transition = withTransition ? 'transform 0.3s ease' : 'none';
    trackEl.style.transform = 'translateX(' + offset + 'px)';
  }

  function updateCounter() {
    counterCurrent.textContent = currentIndex + 1;
    counterTotal.textContent = currentImages.length;
  }

  function showImage(withTransition) {
    if (!currentImages.length) return;
    updateCounter();
    setTrackPosition(withTransition !== false);
  }

    function openLightbox(images, startIndex) {
    currentImages = images;
    currentIndex = startIndex;
    buildSlides();
    lightbox.classList.add('is-open');
    document.body.classList.add('custom-lightbox-open');
    // No transition on open: land directly on the clicked image.
    // (Must run after .is-open is applied, so the stage has a real
    // width to measure — otherwise the track always lands on slide 1.)
    showImage(false);
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.classList.remove('custom-lightbox-open');
  }

  function goTo(index) {
    if (!currentImages.length) return;
    currentIndex = (index + currentImages.length) % currentImages.length;
    showImage(true);
  }

  function showNext(event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    goTo(currentIndex + 1);
  }

  function showPrev(event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    goTo(currentIndex - 1);
  }

  closeBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    closeLightbox();
  });
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);

  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (!lightbox.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowRight') showNext();
    if (event.key === 'ArrowLeft') showPrev();
  });

  // Keep the track aligned to the current slide if the viewport is
  // resized (e.g. orientation change) while the lightbox is open.
  window.addEventListener('resize', function () {
    if (lightbox.classList.contains('is-open')) setTrackPosition(false);
  });

  // --- shared drag handling for touch + mouse ---
  function dragStart(x, y) {
    dragStartX = x;
    dragStartY = y;
    dragDeltaX = 0;
    isDragging = true;
  }

  // Returns true once the drag is confirmed horizontal, so the caller
  // knows whether to suppress the page's own scroll/selection behavior.
  function dragMove(x, y) {
    if (!isDragging) return false;
    dragDeltaX = x - dragStartX;
    var deltaY = y - dragStartY;

    if (Math.abs(dragDeltaX) > Math.abs(deltaY) && Math.abs(dragDeltaX) > 10) {
      setTrackPosition(false, dragDeltaX);
      return true;
    }
    return false;
  }
  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;

    if (dragDeltaX <= -SWIPE_THRESHOLD) {
      goTo(currentIndex + 1); // dragged right-to-left -> next image
    } else if (dragDeltaX >= SWIPE_THRESHOLD) {
      goTo(currentIndex - 1); // dragged left-to-right -> previous image
    } else {
      showImage(true); // snap back to the current slide
    }
    dragDeltaX = 0;
  }

  // --- touch swipe: right-to-left = next, left-to-right = previous ---
  stageEl.addEventListener('touchstart', function (event) {
    if (!event.touches || !event.touches.length) return;
    dragStart(event.touches[0].clientX, event.touches[0].clientY);
  }, { passive: true });

  stageEl.addEventListener('touchmove', function (event) {
    if (!event.touches || !event.touches.length) return;
    var horizontal = dragMove(event.touches[0].clientX, event.touches[0].clientY);
    // Only block native vertical scroll once we're sure this is a
    // horizontal swipe on the slider, same as before.
    if (horizontal) event.preventDefault();
  }, { passive: false });

  stageEl.addEventListener('touchend', dragEnd);
  stageEl.addEventListener('touchcancel', function () {
    isDragging = false;
    dragDeltaX = 0;
    showImage(false);
  });

  // --- mouse drag: lets desktop users drag the slide too ---
  stageEl.addEventListener('mousedown', function (event) {
    isMouseDown = true;
    dragStart(event.clientX, event.clientY);
    event.preventDefault(); // avoid native image drag / text selection
  });

  document.addEventListener('mousemove', function (event) {
    if (!isMouseDown) return;
    dragMove(event.clientX, event.clientY);
  });

  document.addEventListener('mouseup', function () {
    if (!isMouseDown) return;
    isMouseDown = false;
    dragEnd();
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('.product__modal-opener button[data-media-id]');
    if (!opener) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var mediaWrapper = opener.closest('.product__media_container') || document;
    var buttons = Array.from(mediaWrapper.querySelectorAll('.product__modal-opener button[data-media-id]'))
      .filter(function (btn) {
        // Skip any media item currently hidden for a non-selected color,
        // so the lightbox only ever contains the visible variant's images.
        var slide = btn.closest('.product__media-item');
        return !slide || !slide.classList.contains('media-color-hidden');
      });
    if (!buttons.length) return;

    var images = buttons
      .map(function (btn) {
        var wrapper = btn.closest('.product__modal-opener');
        var img = wrapper ? wrapper.querySelector('img') : null;
        return getFullImageSrc(img);
      })
      .filter(Boolean);

    var clickedIndex = buttons.indexOf(opener);
    openLightbox(images, clickedIndex === -1 ? 0 : clickedIndex);
  }, true);
});